import { lazy, Suspense } from "react";
import { useVehicles } from "./hooks/useVehicles";

const VehiclesView = lazy(() => import("./view"));

export default function VehiclesPage() {
  const {
    goBack,
    goToBuy,
    vehicles,
    isShowingMenu,
    toggleMenu,
    searchPlate,
    setSearchPlate,
    selectedVehicles,
    toggleVehicleSelection,
    toggleSelectAll,
    isAllSelected,
    isLoading,
    showTryDelete,
    isVisibleTryDeleteModal,
    setIsVisibleTryDeleteModal,
    requestDelete,
    error,
    setError,
    vehicleToDelete
  } = useVehicles();

  return (
    <Suspense fallback={<div className="h-full bg-gray-100" />}>
      <VehiclesView
        goBack={goBack}
        goToBuy={goToBuy}
        vehicles={vehicles}
        isShowingMenu={isShowingMenu}
        toggleMenu={toggleMenu}
        searchPlate={searchPlate}
        setSearchPlate={setSearchPlate}
        selectedVehicles={selectedVehicles}
        toggleVehicleSelection={toggleVehicleSelection}
        toggleSelectAll={toggleSelectAll}
        isAllSelected={isAllSelected}
        isLoading={isLoading}
        showTryDelete={showTryDelete}
        isVisibleTryDeleteModal={isVisibleTryDeleteModal}
        setIsVisibleTryDeleteModal={setIsVisibleTryDeleteModal}
        requestDelete={requestDelete}
        error={error}
        setError={setError}
        vehicleToDelete={vehicleToDelete}
      />
    </Suspense>
  );
}
